import get from 'lodash/get';
import forEach from 'lodash/forEach';
import intersection from 'lodash/intersection'
import clothing from '~lib/common/config/clothing';
import { caseLogicMsg } from '../validationMessages';

const upperUnderwearIds = [
  'UPPER_UNDERWEAR_REMOVED', 'UPPER_UNDERWEAR_REPLACED'
];

const underwearIds = [
  'UPPER_UNDERWEAR_REMOVED', 'UPPER_UNDERWEAR_REMOVED', 'LOWER_UNDERWEAR_REMOVED', 'LOWER_UNDERWEAR_REPLACED'
];

function isExposeProcedure(action) {
  return (action && action.type === 'PROCEDURE') && (action.id.includes('_REPLACED') || action.id.includes('_REMOVED'));
}

function validateExposeNodes(caseConf, nodeInfo) {
  const errors = [];
  const warnings = [];

  const patientClothing = caseConf.outfit.clothingType;

  const upperUnderwearEnabled = get(caseConf._avatar, 'avatarOptions.upperUnderwear');

  const lowerUnderwearTreatment =
    caseConf._treatments &&
    (caseConf._treatments || []).find((x) => x.id === 'LOWER_UNDERWEAR_REMOVED');
  const removeUnderwearEnabled = lowerUnderwearTreatment ? lowerUnderwearTreatment.options.enabled : false;

  // Actions
  nodeInfo.actionNodes.forEach(node => {
    const action = get(node, 'data.action');
    if (!isExposeProcedure(action)) {
      return;
    }
    const clothingKey = action.id.substring(0, action.id.lastIndexOf('_'));
    const clothingItem = clothing.find(item => item.key === clothingKey);
    if (
      (clothingItem && clothingItem.outfitRestrictions && !clothingItem.outfitRestrictions.includes(patientClothing)) ||
      (upperUnderwearIds.includes(action.id) && !upperUnderwearEnabled)
    ) {
      warnings.push(
        caseLogicMsg('Selected clothing not available for current patient', node.id, { errorId: 'clothingUnvailalbe' })
      );
    } else if (underwearIds.includes(action.id) && !removeUnderwearEnabled) {
      warnings.push(
        caseLogicMsg('Selected clothing not removable', node.id, { errorId: 'clothingUnremovable' })
      );
    }
  });

  // Checks
  nodeInfo.checkNodes.forEach((node) => {
    forEach(node.data, (check, checkKey) => {
      if (check.type !== 'EXPOSED') {
        return;
      }
      const isRestrictedOutfit = check.value.reduce((accum, procedureKey) => {
        const clothingKey = procedureKey.substring(0, procedureKey.lastIndexOf('_'));
        const clothingItem = clothing.find(item => item.key === clothingKey);
        return accum || (clothingItem.outfitRestrictions && !clothingItem.outfitRestrictions.includes(patientClothing));
      }, false);
      if (
        isRestrictedOutfit ||
        (intersection(upperUnderwearIds, check.value).length && !upperUnderwearEnabled)
      ) {
        warnings.push(
          caseLogicMsg('Selected clothing not available for current patient', node.id, { checkKey, errorId: 'clothingUnvailalbe' })
        );
      } else if (intersection(underwearIds, check.value).length && !removeUnderwearEnabled) {
        warnings.push(
          caseLogicMsg('Selected clothing not removable', node.id, { checkKey, errorId: 'clothingUnremovable' })
        );
      }
    });
  });

  return {
    errors,
    warnings,
  };
}

export default validateExposeNodes;